export default function ResultadoPrevisivelAcelera() {
  return (
    <section className="py-24 lg:py-32 bg-white relative overflow-hidden">
      <div className="container relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-20">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-semibold text-slate-900 leading-tight">
              Resultado <span className="text-orange-600">Previsível</span>
            </h2>
          </div>
          
          {/* Content Grid */}
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left: Text Content */}
            <div className="space-y-10 order-2 lg:order-1">
              {/* Contraste/Problema */}
              <div className="space-y-4">
                <p className="text-xl text-gray-600 leading-loose">
                  Enquanto muitas empresas não sabem quanto realmente ganham com o marketing,{' '}
                  <span className="text-slate-900 font-semibold">
                    nós acompanhamos cada etapa do funil em tempo real.
                  </span>
                </p>
              </div>
              
              {/* Tripé Positivo */}
              <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
                <div className="space-y-5">
                  <div className="flex items-center gap-4 pb-5 border-b border-gray-200">
                    <div className="w-1 h-8 bg-orange-600 rounded-full"></div>
                    <p className="text-xl font-semibold text-slate-900">Tudo claro.</p>
                  </div>
                  
                  <div className="flex items-center gap-4 pb-5 border-b border-gray-200">
                    <div className="w-1 h-8 bg-orange-600 rounded-full"></div>
                    <p className="text-xl font-semibold text-slate-900">Tudo mensurado.</p>
                  </div>
                  
                  <div className="flex items-center gap-4">
                    <div className="w-1 h-8 bg-orange-600 rounded-full"></div>
                    <p className="text-xl font-semibold text-slate-900">Tudo otimizado.</p>
                  </div>
                </div>
              </div>
              
              {/* Promessa Central */}
              <div className="text-center lg:text-left">
                <p className="text-lg text-gray-600 mb-3">Isso significa uma coisa:</p>
                <p className="text-3xl lg:text-4xl font-semibold text-orange-600">
                  crescimento previsível.
                </p>
              </div>
              
              {/* Tripé Negativo */}
              <div className="bg-slate-900 rounded-2xl p-8 border-l-4 border-gray-400">
                <div className="space-y-5">
                  <div className="flex items-center gap-4 pb-5 border-b border-white/10">
                    <div className="w-1.5 h-1.5 bg-gray-400 rounded-full"></div>
                    <p className="text-lg font-medium text-gray-400">Sem achismo.</p>
                  </div>
                  
                  <div className="flex items-center gap-4 pb-5 border-b border-white/10">
                    <div className="w-1.5 h-1.5 bg-gray-400 rounded-full"></div>
                    <p className="text-lg font-medium text-gray-400">Sem improviso.</p>
                  </div>
                  
                  <div className="flex items-center gap-4">
                    <div className="w-1.5 h-1.5 bg-gray-400 rounded-full"></div>
                    <p className="text-lg font-medium text-gray-400">Sem depender de indicação.</p>
                  </div>
                </div>
              </div>
              
              {/* Fechamento Impactante */}
              <div className="bg-orange-50 rounded-2xl p-8 border-l-4 border-orange-600">
                <p className="text-xl font-semibold text-slate-900 leading-relaxed">
                  Se você não enxerga sua empresa com esse nível de clareza,{' '}
                  <span className="text-orange-600">você está operando no escuro.</span>
                </p>
              </div>
            </div>
            
            {/* Right: Image */}
            <div className="order-1 lg:order-2">
              <div className="relative group">
                {/* Image */}
                <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-200 transform transition-all duration-500 hover:shadow-3xl">
                  <img
                    src="/images/kpis-dashboard.png"
                    alt="Dashboard de KPIs em tempo real mostrando métricas de performance, funil de vendas, taxa de conversão e resultados previsíveis"
                    className="w-full h-auto object-cover"
                    loading="lazy"
                  />
                  
                  {/* Subtle overlay on hover */}
                  <div className="absolute inset-0 bg-slate-900/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
                
                {/* Minimalist badge */}
                <div className="absolute -bottom-4 -right-4 bg-slate-900 text-white px-6 py-3 rounded-lg shadow-xl border border-white/10">
                  <span className="font-semibold text-sm tracking-wide">TEMPO REAL</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
